import errorLogService from 'src/utils/errorLogService';
import { mapStackTrace } from 'sourcemapped-stacktrace';

import useAlertContext from './useAlertContext';

const useHandleError = () => {
  const { setAlert, setUnhandledError } = useAlertContext();

  const reportError = (error) => {
    try {
      mapStackTrace(error.stack, (mappedStack) => {
        errorLogService(error, mappedStack.join('\n'));
      });
    } catch (e) {
      errorLogService(error, error.stack);
    }
  };

  /**
   *
   * @param {Error} error Error object
   * @param {Function} suppressAlert function must return boolean
   */
  const handleError = (error, suppressAlert = null) => {
    if (error.response) {
      const {
        response: { data: errorData }
      } = error;
      const showAlert = suppressAlert ? suppressAlert() : true;
      if (showAlert) {
        setAlert({
          message: errorData.message || errorData.errors,
          action: null
        });
      }
    } else {
      reportError(error);
      setUnhandledError();
    }
  };

  return { handleError, reportError };
};

export default useHandleError;
